/**
 * Kleine Regeln zum Entfernen eines Bestelldokuments (Spec
 * `docs/superpowers/specs/2026-10-16-dokument-entfernen-design.md`). Kein Bestandsvorbild in `index.html`
 * (dort gab es nur `removeDoc` auf dem `pdfs`-Feld) - deshalb hier und nicht in einem portierten Modul.
 */
import type { OrderDocument } from "./types.ts";
import type { DokumentHerkunft } from "../api/dokumente.ts";
import { ZAHLUNGSBELEG_TYPEN } from "./zahlungsbelege.ts";

/**
 * Welche Rechte das Entfernen eines Dokuments dieses Typs freischalten (EINES genuegt, wie bei
 * `drawerRechte.ts#hatRecht`): wie beim Upload `manage_documents`, bei Zahlungsbelegtypen (`anzahlungsbeleg`,
 * `restzahlungsbeleg`, `ZAHLUNGSBELEG_TYPEN` in `lib/zahlungsbelege.ts`, Gegenstueck zu `backend/src/documents/docTypes.ts`) auch
 * `manage_payments` - die Zahlungsrolle pflegt ihren eigenen Beleg. Der Server urteilt verbindlich
 * (`berechtigungFuerDokumenttyp`); diese Liste spart nur den aussichtslosen Versuch.
 */
export function entfernenRechte(docType: string): string[] {
  return ZAHLUNGSBELEG_TYPEN.has(docType) ? ["manage_documents", "manage_payments"] : ["manage_documents"];
}

/**
 * Herkunft der Verknuepfung. Der Server liefert sie in der Belegliste (`herkunft`); fehlt sie (Antwort
 * ohne das Feld, `pdfs`-Rueckfall vor dem ersten Laden), wird sie aus den vorhandenen Feldern abgeleitet,
 * damit ein geerbtes Dokument nie mit der Ein-Klick-Rueckfrage eines eigenen entfernt wird.
 */
export function herkunftVon(dokument: OrderDocument): DokumentHerkunft {
  if (dokument.herkunft) return dokument.herkunft;
  if (dokument.viaGroupId) return "gruppe";
  if (dokument.viaShipmentNo) return "sendung";
  return "eigen";
}

/**
 * Ob eine Zeile einen Muelleimer bekommt: eine Zeile aus der Belegliste (`index === -1`, hat `id` +
 * `rowVersion`) oder aus dem `pdfs`-Rueckfall (`index >= 0`, Strukturparitaet zum Bestand - fehlen dort
 * `id`/`rowVersion`, meldet `DokumenteTab.tsx#loeschen` den Fehlschlag laut statt still).
 */
export function kannEntfernen(dokument: OrderDocument, index: number): boolean {
  return index >= 0 || (typeof dokument.id === "string" && typeof dokument.rowVersion === "number");
}

/** Zahl der Bestellungen, die „Alle“ trifft; fehlt `reichweiteAnzahl`, hilft `geteiltMit`, sonst 1. */
export function reichweiteAnzahlVon(dokument: OrderDocument): number {
  if (typeof dokument.reichweiteAnzahl === "number" && dokument.reichweiteAnzahl > 0) {
    return dokument.reichweiteAnzahl;
  }
  if (typeof dokument.geteiltMit === "number" && dokument.geteiltMit > 0) return dokument.geteiltMit;
  return 1;
}
